import React from "react";
import { Link } from "react-router-dom";

const CouponHeader = () => {
    return (
        <div className="coupon-header">

            <div>
                <h2>Coupons & Offers</h2>
                <p>Manage all coupons, offers and promotional campaigns.</p>
            </div>

            <Link
                to="/admin/coupons/create"
                className="btn btn-primary"
            >
                + Create Coupon
            </Link>

        </div>
    );
};

export default CouponHeader;